import * as ng from 'angular';

import { PanelHeaderData } from '@/atomic-components/molecules/panels';
import { AlertManagerService, MachineModelService } from '@/services';
import { ApiErrorModel } from '@/services/errors/api-error-model';
import { MachineApi } from '@/types/machine-api';

export class TemplateMachineInterfacesController {
    public static $inject: string[] = ['$translate', 'alertManager', 'apiErrorModel', 'machineModel'];

    public pageHeaderData: PanelHeaderData;
    public machine: MachineApi.VirtualMachine;
    public panelRightSettings;
    public selectedNetwork: string;

    private originalRdns: Map<string, string> = new Map();

    constructor(
        private $translate: ng.translate.ITranslateService,
        private alertManager: AlertManagerService,
        private apiErrorModel: ApiErrorModel,
        private machineModel: MachineModelService
    ) {}

    public $onInit = () => {
        this.pageHeaderData = {
            backwardLink: 'machine.virtualmachines.id.edit',
            backwardText: this.$translate.instant('TR_140119-0389cf_TR'),
            panelHeaderRoute: '',
            panelHeaderRouteParams: null,
            panelIcon: 'server',
            panelTitle: this.machine.name
        };

        this.panelRightSettings = {
            editPanelButton: true
        };

        this.captureRdnsSnapshot();
    };

    public resetMachineData = async () => {
        this.machine = await this.machineModel.findOneById(this.machine.id);
        this.captureRdnsSnapshot();
    };

    public updateInterfaceRdns = () => {
        this.machine.networkInterfaces
        .filter(networkIface => networkIface.id === this.selectedNetwork)
        .forEach((iface) => {
            iface.ipAddresses.forEach((address) => {
                const current = this.normalizeRdns(address.rdns);
                const original = this.originalRdns.get(address.ip) ?? '';
                if (current === original) {
                    return;
                }
                this.machineModel.setRDNS(address.ip, current).then(
                    (res) => {
                        if (!this.apiErrorModel.apiResponseHasError(res)) {
                            this.originalRdns.set(address.ip, current);
                            return res;
                        }
                        return Promise.reject(false);
                    }
                );
            });
        });
        this.alertManager.success(this.$translate.instant('TR_100119-139c51_TR'));
    };

    private captureRdnsSnapshot = () => {
        this.originalRdns.clear();
        this.machine.networkInterfaces.forEach((iface) => {
            iface.ipAddresses.forEach((address) => {
                this.originalRdns.set(address.ip, this.normalizeRdns(address.rdns));
            });
        });
    };

    private normalizeRdns = (rdns: string | null | undefined): string => rdns ?? '';
}

export class TemplateMachineInterfacesComponent implements ng.IComponentOptions {
    public bindings = {
        machine: '<'
    };
    public template = require('./machine-interfaces.html');
    public controller = TemplateMachineInterfacesController;
}
